import React, {useLayoutEffect, useRef, useState} from "react";
import {observer} from "mobx-react-lite";
import {Select} from "../form/Select";
import {getUserOptions} from "../../../utils/getUserOptions";
import {LoadingCircle} from "../LoadingCircle";
import {useUserState, useDsManager} from "@stores/AppStateContext";

interface MultiSelectWorkspaceMembersProps {
    value: string[] | null;
    onChange: (newValues: string[] | null) => void;
    targetWorkspaceId: string;
    placeholder?: string;
    className?: string;
    size?: "small" | "medium" | "large";
    withLabel?: boolean;
    onlyAvailableToBeAdded?: boolean;
}

export const MultiSelectWorkspaceMembers = observer((
    {
        value,
        onChange,
        placeholder,
        className,
        withLabel = true,
        size = "large",
        onlyAvailableToBeAdded = false,
        targetWorkspaceId,
    }: MultiSelectWorkspaceMembersProps
) => {
    const userState = useUserState();
    const dsManager = useDsManager();
    const [isLoading, setIsLoading] = useState(true);
    const wsUsersDataSourceRef = useRef(dsManager?.getWsUsersDataSource(targetWorkspaceId));

    useLayoutEffect(() => {
        if (!wsUsersDataSourceRef.current?.isInitialized) {
            wsUsersDataSourceRef.current!.initialLoad();
            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    }, [wsUsersDataSourceRef.current])

    if (isLoading) {
        return (
            <LoadingCircle/>
        )
    }

    const wsUsers = wsUsersDataSourceRef.current!.allRows;
    const existingUserIds = wsUsers.map(wsUser => wsUser.userId);
    existingUserIds.push(userState!.ownerUserId!);
    const users = userState!.usersDS.activeUsers;
    const options = getUserOptions(users!.filter(user => {
        if (onlyAvailableToBeAdded) {
            return !existingUserIds.includes(user.id);
        } else {
            return existingUserIds.includes(user.id);
        }
    }));

    return (
        <Select
            className={className}
            selectedValues={value}
            options={options}
            placeholder={placeholder}
            size={size}
            onChange={onChange}
            allowFilter={true}
            isFullWidth={true}
            allowMulti={true}
            withLabel={withLabel}
            withBorder={true}
        />
    );
});
